module.exports = __webpack_public_path__ + "img/HX.7ff0be01.png";